import { render, staticRenderFns } from "./KYC_v2.vue?vue&type=template&id=951a2bb0&scoped=true"
import script from "./KYC_v2.vue?vue&type=script&lang=js"
export * from "./KYC_v2.vue?vue&type=script&lang=js"
import style0 from "./KYC_v2.vue?vue&type=style&index=0&id=951a2bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a2bb0",
  null
  
)

export default component.exports